import React from "react";

function AbtBanner({ data: response }) {
  const { data } = response || { data: [] };
  return (
    <>
      <section className="orion_highlight">
        {/* <div className="container"> */}
        <div className="row no-gap">
          {data?.length > 0 &&
            data?.map((item, index) => (
              <div
                className="col-md-4 position-relative orion_highlight_card"
                key={index}
              >
                <img
                  src={`${process.env.REACT_APP_UPLOAD_URL}${item.imagePath}`}
                  alt={item.label}
                  className="img-fluid"
                />
                <div
                  className="overlay-title text-capitalize"
                  data-aos="fade-up"
                  data-aos-duration={1500}
                >
                  {item.label}
                </div>
                <div
                  className="overlay-text"
                  data-aos="zoom-in"
                  data-aos-duration={1500}
                  dangerouslySetInnerHTML={{ __html: item.content }}
                ></div>
              </div>
            ))}
        </div>
        {/* </div> */}
      </section>
    </>
  );
}

export default AbtBanner;
